import reducer from "./reducers";

import * as personAction from "./actions";

export { personAction };

export default reducer;
